module.exports = __webpack_public_path__ + "img/sellers.167b1797.png";